import React from 'react';
import { Facebook, Instagram, Youtube, Phone, Mail, CreditCard, Truck, Shield, RefreshCw } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0e0e0e] text-gray-300">
      {/* Trust strip */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: Truck, title: 'Livrare rapidă', text: 'În toată țara' },
            { icon: Shield, title: 'Garanție extinsă', text: 'Până la 10 ani' },
            { icon: RefreshCw, title: 'Retur 14 zile', text: 'Fără întrebări' },
            { icon: CreditCard, title: 'Plată sigură', text: 'Card sau ramburs' }
          ].map((f, i) => (
            <div key={i} className="flex items-start gap-3">
              <f.icon className="w-7 h-7 text-amber-500 flex-shrink-0 mt-0.5" />
              <div>
                <div className="text-white font-semibold text-sm">{f.title}</div>
                <div className="text-xs text-gray-400">{f.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex flex-col items-start leading-none mb-5">
            <span className="font-extrabold tracking-tight text-white" style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: '38px', letterSpacing: '-0.02em' }}>
              EddMa
            </span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-amber-500 font-medium -mt-0.5">
              metal art
            </span>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed mb-5">
            Porți, garduri și pergole din aluminiu, lucrate manual cu pasiune. Calitate premium pentru casa ta.
          </p>
          <div className="flex gap-3">
            {[Facebook, Instagram, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-amber-500 flex items-center justify-center transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Categorii */}
        <div>
          <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Categorii</h4>
          <ul className="space-y-2 text-sm">
            {['Porți din aluminiu', 'Panouri gard', 'Pergole', 'Mobilier grădină', 'Umbrele', 'Decking', 'Depozitare'].map((c) => (
              <li key={c}>
                <a href="#" className="hover:text-amber-500 transition-colors">{c}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Info */}
        <div>
          <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Informații</h4>
          <ul className="space-y-2 text-sm">
            {['Despre noi', 'Portofoliu', 'Termeni și condiții', 'Politica de confidențialitate', 'Livrare și retur', 'Garanție', 'Blog'].map((c) => (
              <li key={c}>
                <a href="#" className="hover:text-amber-500 transition-colors">{c}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <Phone className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" />
              <div>
                <div>0747 825 465</div>
                <div className="text-gray-500 text-xs">Luni - Vineri, 09:00 - 18:00</div>
              </div>
            </li>
            <li className="flex items-start gap-2.5">
              <Mail className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" />
              <span>eddma.metal.art@gmail.com</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} EddMa Metal Art. Toate drepturile rezervate.</div>
          <div className="flex gap-3">
            <span>VISA</span>
            <span>MasterCard</span>
            <span>Maestro</span>
            <span>PayPal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
